/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_OpenInputs */

const en_us2_exercise_sheet_report_open = /** @type {(inputs: Exercise_Sheet_Report_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrong data?`)
};

const pt_br2_exercise_sheet_report_open = /** @type {(inputs: Exercise_Sheet_Report_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados errados?`)
};

const es_419_exercise_sheet_report_open = /** @type {(inputs: Exercise_Sheet_Report_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Datos incorrectos?`)
};

const pt_pt2_exercise_sheet_report_open = /** @type {(inputs: Exercise_Sheet_Report_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados errados?`)
};

const fr_fr2_exercise_sheet_report_open = /** @type {(inputs: Exercise_Sheet_Report_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données erronées ?`)
};

const de_de2_exercise_sheet_report_open = /** @type {(inputs: Exercise_Sheet_Report_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerhafte Daten?`)
};

const it_it2_exercise_sheet_report_open = /** @type {(inputs: Exercise_Sheet_Report_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati sbagliati?`)
};

/**
* | output |
* | --- |
* | "Wrong data?" |
*
* @param {Exercise_Sheet_Report_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_open = /** @type {((inputs?: Exercise_Sheet_Report_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_open(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_open(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_open(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_open(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_open(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_open(inputs)
	return en_us2_exercise_sheet_report_open(inputs)
});
export { exercise_sheet_report_open as "exercise-sheet.report_open" }